<template>
  <div class="com-mod-section-container">
    <h3 class="com-mod-section-header">
      Fees & Expenses
      <disclosure-superscript
        class="detail-page"
        anchor="feesExpenses"
        :statistics="['expRatio']"
      />
    </h3>
    <div class="row">
      <div class="col-md-12 col-md-6">
        <Fees />
      </div>
      <div class="col-md-12 col-md-6">
        <Expenses />
      </div>
    </div>
  </div>
</template>

<script>
import Fees from '_components_/Modules/Fees';
import Expenses from '_components_/Modules/Expenses';
export default {
	name: 'FeesAndExpenses',
	components: {
		Fees,
		Expenses
	}
};
</script>

<style>
	@import '~_css_/module.css';
</style>
